import { TeamMember } from '@marageti/z4-sdk/lib/people';
import { SearchRequest, SearchResult } from '@marageti/z4-sdk/lib/entity';
import { RoleName, UserStatus } from '@marageti/z4-sdk/lib/auth';
import { titleCase } from '../helpers';

export type Option = {
  title: string;
  value: string;
};

export type AssigneeOption = Option & {
  status?: string;
};

export const ANY_ASSIGNEE: AssigneeOption = { title: 'All', value: '' };
const UNASSIGNED_ASSIGNEE: AssigneeOption = { title: 'Unassigned', value: 'UNASSIGNED' };

export const teamMemberSearchRequest: SearchRequest = {
  filterBy: [{ field: 'userInfo.roles', value: [RoleName.CARE] }],
  pagination: { limit: 1000, page: 1 },
  sortBy: [{ field: 'userInfo.status', order: 'desc' }],
};

export const formatTeamMembersAsOptions = (
  teamMembers: SearchResult<TeamMember> | undefined,
  defaultTeamOptions: AssigneeOption[] = [ANY_ASSIGNEE, UNASSIGNED_ASSIGNEE],
): AssigneeOption[] => {
  if (!teamMembers) return defaultTeamOptions;

  const options: Record<UserStatus, AssigneeOption[]> = {
    ENABLED: [],
    PENDING: [],
    DISABLED: [],
  } as Record<UserStatus, AssigneeOption[]>;

  teamMembers.hits.forEach((teamMember) => {
    options[teamMember.userInfo[0].status].push({
      title: teamMember.fullName,
      value: teamMember.id,
      status: teamMember.userInfo[0].status === UserStatus.ENABLED
        ? '--- Active ---' : `--- ${titleCase(teamMember.userInfo[0].status)} ---`,
    });
  });

  options.ENABLED.sort((a, b) => a.title.localeCompare(b.title));
  options.PENDING.sort((a, b) => a.title.localeCompare(b.title));
  options.DISABLED.sort((a, b) => a.title.localeCompare(b.title));

  return [...defaultTeamOptions, ...options.ENABLED, ...options.PENDING, ...options.DISABLED];
};
